<template>
  <div class="container-custom">
    <v-form ref="form" @submit.prevent="saveHandler">
      <Breadscrumbs
        :links="[
          {
            name: 'StoryCenter',
            to: {
              name: 'StoryCenter'
            }
          },
          {
            name: 'Edit',
            to: {
              name: 'StoryEdit',
              params: {
                id: $route.params.id
              }
            }
          }
        ]"
      ></Breadscrumbs>
      <!-- page-actions -->
      <div class="page-actions">
        <h2>修改案例</h2>
        <v-spacer></v-spacer>
        <button class="btn mr-5" @click="cancelHandler">
          <span>取消</span>
        </button>
        <button class="btn btn-primary" type='submit'>
          <span>儲存</span>
        </button>
      </div>
    </v-form>
    <!-- Block 新增案例 -->
    <StoryCreateEdit></StoryCreateEdit>
    <LangDialog :isOpen.sync="isLangOpen" @confirm-submit="saveHandler()"></LangDialog>
    <!-- PageMenu -->
    <div class="block">
      <PageMenu :sections="sections">
        <component :is="sectionView"></component>
      </PageMenu>
    </div>
  </div>
</template>
<script>
import { mapActions, mapState } from 'vuex';
import PageMenu from '@/components/PageMenu.vue';
import Breadscrumbs from '@/components/Breadscrumbs.vue';
import StoryCreateEdit from '@/views/E-5__SuccessStory/c/StoryCreateEdit.vue';
import TabTech from '@/views/E-5__SuccessStory/c/StoryTechnology.vue';
import TabProd from '@/views/E-5__SuccessStory/c/StoryProduct.vue';
import TabGallery from '@/views/E-5__SuccessStory/c/StoryProductGallery.vue';
import LangDialog from '@/components/LangSubmitDialog.vue';

export default {
  components: {
    Breadscrumbs,
    PageMenu,
    TabTech,
    TabProd,
    TabGallery,
    StoryCreateEdit,
    LangDialog,
  },
  data: () => ({
    isLangOpen: false,
    sections: [
      { name: 'Tech', component: 'TabTech' },
      { name: 'Prod', component: 'TabProd' },
      { name: 'Gallery', component: 'TabGallery' },
    ],
  }),
  computed: {
    ...mapState(['lang']),
    ...mapState('story', ['story']),
    sectionIndex() {
      const vm = this;
      return vm.$route.query.section || 0;
    },
    sectionView() {
      const vm = this;
      return vm.sections[vm.sectionIndex].component;
    },
  },
  async created() {
    if (this.$route.params.id) {
      await this.getStory(this.$route.params.id);
    }
  },
  methods: {
    ...mapActions('story', {
      getStory: 'findById',
      save: 'save',
    }),
    cancelHandler() {
      this.$router.push({ name: 'StoryCenter' });
    },
    saveHandler() {
      if (this.isLangOpen || !this.lang.id) {
        this.errors = [];
        if (this.$refs.form.validate()) {
          if (!this.story.title) {
            this.errors.push('應用產品 required.');
          } else if (!this.story.bu_application_details_id) {
            this.errors.push('應用[Application] required.');
          } else if (!this.story.slug) {
            this.errors.push('Slug required.');
          }
          if (this.errors.length > 0) {
            /* eslint-disable */
            alert(this.errors);
            /* eslint-disable */
            return false;
          }
          this.save(this.story).then(() => {
            this.$router.push({ name: 'StoryCenter' });
          });
        }
      } else {
        this.isLangOpen = true;
      }
    },
  },
};
</script>

<style></style>
